@if (image(); as src) {
  <img fill [alt]="name()" [ngSrc]="src">
} @else if (showIcon()) {
  <span data-icon>
    <bspk-icon name="Person" />
  </span>
} @else if (initialsValue()) {
  <span data-initials>{{ initialsValue() }}</span>
}
